<template>
  <div class="sidebar-pinned">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-thermometer" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Hello, {{ auth_user.firstname }} {{ auth_user.lastname }}</h4>
              <small style="opacity: 0.8;">Laboratorist</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -32px;">
        <div class="container pb-5">

          <!-- ── Stat Cards ── -->
          <div class="row mb-4">
            <div class="col-lg-4 col-md-6 mb-3">
              <router-link to="/my-dependents" class="text-decoration-none">
                <div class="card shadow stat-card h-100" style="border-left: 4px solid #2563eb;">
                  <div class="card-body d-flex align-items-center py-3 px-4">
                    <div class="mr-3"
                      style="width: 44px; height: 44px; background: #eef2ff; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <i class="fe fe-calendar" style="font-size: 20px; color: #2563eb;"></i>
                    </div>
                    <div>
                      <p class="mb-0 text-muted"
                        style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">Manage Reports</p>
                      <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">{{ dependents.length || '—' }}</h3>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-4 col-md-6 mb-3">
              <router-link to="/my-dependents" class="text-decoration-none">
                <div class="card shadow stat-card h-100" style="border-left: 4px solid #10b981;">
                  <div class="card-body d-flex align-items-center py-3 px-4">
                    <div class="mr-3"
                      style="width: 44px; height: 44px; background: #ecfdf5; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <i class="fe fe-users" style="font-size: 20px; color: #10b981;"></i>
                    </div>
                    <div>
                      <p class="mb-0 text-muted"
                        style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">Patients</p>
                      <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">{{ dependents.length || '—' }}</h3>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-4 col-md-6 mb-3">
              <router-link to="/my-dependents" class="text-decoration-none">
                <div class="card shadow stat-card h-100" style="border-left: 4px solid #f59e0b;">
                  <div class="card-body d-flex align-items-center py-3 px-4">
                    <div class="mr-3"
                      style="width: 44px; height: 44px; background: #fffbeb; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <i class="fe fe-clipboard" style="font-size: 20px; color: #f59e0b;"></i>
                    </div>
                    <div>
                      <p class="mb-0 text-muted"
                        style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">Notice Boards</p>
                      <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">{{ dependents.length || '—' }}</h3>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <!-- ── Notice Board Table ── -->
          <div class="card shadow table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-book text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Notice Board</h6>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th px-4">Complain Number</th>
                    <th class="table-th">Title</th>
                    <th class="table-th">Type</th>
                    <th class="table-th">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="complaint in complaints" v-bind:key="complaint.id" class="table-row">
                    <td class="px-4 py-3"><span class="code-chip">122333932</span></td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ complaint.title }}</td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ complaint.type }}</td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ complaint.status }}</td>
                  </tr>
                  <tr v-if="!complaints || !complaints.length">
                    <td colspan="4" class="text-center py-5 text-muted">
                      <i class="fe fe-clipboard" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No notices found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from '@/views/Navbar.vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      auth_user:"",
      dependents:"",
      myplan:"",
      wallet:"",
      complaints:"",
      isLoading: false,
      fullPage: true,
      user:null

    }
  },
  beforeMount(){

    this.axios.get(`/api/v1/auth/user`)
                .then(response => {
                    this.auth_user = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    getDependents(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/allDependantUser/${this.user.id}`)
                  .then(response => {
                      this.dependents = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getPlan(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/userSubscribedPlan`)
                  .then(response => {
                      this.myplan = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getComplaints(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/complaints/${this.user.id}`)
                  .then(response => {
                      this.complaints = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getWallet(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/getUserWallet`)
                  .then(response => {
                      this.wallet = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }

  },
  created(){
    this.getDependents()
    this.getComplaints()
    this.getPlan()
    this.getWallet()
  }
}
</script>
<style lang="css" scoped>
  .stat-card {
    border-radius: 12px;
    transition: transform 0.15s, box-shadow 0.15s;
  }

  .stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1) !important;
  }
</style>
